"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalReportFieldToJSON = exports.InternalReportFieldFromJSONTyped = exports.InternalReportFieldFromJSON = exports.instanceOfInternalReportField = void 0;
var runtime_1 = require("../runtime");
var InternalReportFieldType_1 = require("./InternalReportFieldType");
/**
 * Check if a given object implements the InternalReportField interface.
 */
function instanceOfInternalReportField(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfInternalReportField = instanceOfInternalReportField;
function InternalReportFieldFromJSON(json) {
    return InternalReportFieldFromJSONTyped(json, false);
}
exports.InternalReportFieldFromJSON = InternalReportFieldFromJSON;
function InternalReportFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldType': !(0, runtime_1.exists)(json, 'field_type') ? undefined : (0, InternalReportFieldType_1.InternalReportFieldTypeFromJSON)(json['field_type']),
        'fieldValue': !(0, runtime_1.exists)(json, 'field_value') ? undefined : json['field_value'],
    };
}
exports.InternalReportFieldFromJSONTyped = InternalReportFieldFromJSONTyped;
function InternalReportFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'field_type': (0, InternalReportFieldType_1.InternalReportFieldTypeToJSON)(value.fieldType),
        'field_value': value.fieldValue,
    };
}
exports.InternalReportFieldToJSON = InternalReportFieldToJSON;
